const US_TRADEIN_URL = "https://www.resale.arcteryx.com/pages/trade-it-in";
const CA_EN_TRADEIN_URL = "https://resale.arcteryx.ca/pages/trade-it-in";
const CA_FR_TRADEIN_URL = "https://resale.arcteryx.ca/fr/pages/trade-it-in";

const US_RESALE_URL = "https://www.resale.arcteryx.com";
const CA_EN_RESALE_URL = "https://resale.arcteryx.ca";
const CA_FR_RESALE_URL = "https://resale.arcteryx.ca/fr";

export const resaleRedirect = (country, language) => {
  let resaleUrl = "https://www.resale.arcteryx.com";
  if (country?.toLowerCase() === "us") {
    resaleUrl = US_RESALE_URL;
  }
  if (country?.toLowerCase() === "ca") {
    resaleUrl = language === "fr" ? CA_FR_RESALE_URL : CA_EN_RESALE_URL;
  }
  return resaleUrl;
};

// not DRY, but too many url params and conditional logic to combine
export const tradeInRedirect = (country, language) => {
  let resaleUrl = "https://www.resale.arcteryx.com";
  if (country?.toLowerCase() === "us") {
    resaleUrl = US_TRADEIN_URL;
  }
  if (country?.toLowerCase() === "ca") {
    resaleUrl = language === "fr" ? CA_FR_TRADEIN_URL : CA_EN_TRADEIN_URL;
  }
  return resaleUrl;
};
